import {DND_HANDLE_COLUMN_WIDTH, ADD_COLUMN_WIDTH} from "./columns"

const debug = false
// const debug = "WidthCalculatorFull"

export default class WidthCalculatorFull {

    private columnsManager  : any

    constructor(columnsManager:any) {
        debug && console.log(debug, "constructor()", columnsManager)

        this.columnsManager = columnsManager
    }

    calculateTotalWidth():number {
        // we need min total width
        const pageWith = this.columnsManager.module.getMaxWidth()
        debug && console.log(debug,  "page width=", pageWith)
        debug && console.log(debug,  "titleField=", this.columnsManager.module.config.titleField)

        let totalWidth              = 0
        let totalWidthWithoutTitle  = 0
        let titleMinWidth           = 0
        let titleWidth              = 0

        const titleColumn           = this.columnsManager.get(this.columnsManager.module.config.titleField)

        let haveAutoWidthColumn     = false

        _.map(this.columnsManager._columns, (column)=>{
            if (column.isHidden) return // skip hidden columns

            if (column.isAutoWidth) {
                // console.log("title field skip")
                haveAutoWidthColumn     = true
                titleMinWidth           = column.minWidth

            } else {
                // console.log("not title - calculate")
                totalWidthWithoutTitle  += column.width
            }
        })

        // patches
        totalWidthWithoutTitle += this.columnsManager.module.skin.paddingLeft + this.columnsManager.module.skin.paddingRight
        if (this.columnsManager.module.canDndItems)    totalWidthWithoutTitle += DND_HANDLE_COLUMN_WIDTH
        if (this.columnsManager.module.canAddColumns)  totalWidthWithoutTitle += ADD_COLUMN_WIDTH

        if (haveAutoWidthColumn) {
            if (totalWidthWithoutTitle + titleMinWidth < pageWith) {
                titleWidth = pageWith - totalWidthWithoutTitle

                // never make it smaller
                if (titleWidth < titleColumn.minWidth) {
                    titleWidth = titleColumn.minWidth
                }
            } else {
                titleWidth = titleMinWidth
            }

            // we need to set width for this column as we changed it dynamically here
            titleColumn.width = titleWidth

            totalWidth = totalWidthWithoutTitle + titleWidth
        } else {
            totalWidth = totalWidthWithoutTitle
        }

        debug && console.log(debug, "calculateTotalWidth()  ")
        debug && console.log(debug, "    haveAutoWidthColumn=", haveAutoWidthColumn)
        debug && console.log(debug, "    titleWidth=", titleWidth)
        debug && console.log(debug, "    totalWidthWithoutTitle=", totalWidthWithoutTitle)
        debug && console.log(debug, "    totalWidth=", totalWidth)

        // if all small - still 100%
        if (totalWidth < pageWith) {
            totalWidth = pageWith
        }

        return totalWidth
    }
}